import { apiClient } from '@/core/api/client';
import type {
  EligibleAdvisorReferralClientsResponse,
  ReferAdvisorPayload,
  ReferAdvisorResponse,
} from '../types/advisor-referrals.types';

export const advisorReferralsApi = {
  getEligibleClients: async (): Promise<EligibleAdvisorReferralClientsResponse> => {
    const response = await apiClient.get<EligibleAdvisorReferralClientsResponse>(
      '/client-relationships/eligible-for-fa-referral',
    );
    return response.data;
  },

  referAdvisor: async (payload: ReferAdvisorPayload): Promise<ReferAdvisorResponse> => {
    const response = await apiClient.post<ReferAdvisorResponse>('/referrals/refer-to-fa', payload);
    return response.data;
  },
};
